import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BoxedSliderField } from "web_myplann/Inspiration/Components/BoxedSliderField";
import { InspirationSheet } from "web_myplann/Inspiration/Components/InspirationSheet";
import {
	OWN_HOME_INCOME_FIELD,
	OWN_HOME_RENT_FIELD,
	OWN_HOME_SAVINGS_FIELD,
} from "web_myplann/Inspiration/constants";
import { useOwnHomeEstimate } from "web_myplann/Inspiration/Hooks/useOwnHomeEstimate";

type Props = {
	open: boolean;
	onClose: () => void;
	onSubmit: (data: { rent: number; income: number; savings?: number }) => void;
	onSaveToBilance: () => void;
};

const PageResources = Resources.Inspiration.OwnHome.Sheet;

export const OwnHomeEstimateSheet: FC<Props> = ({
	open,
	onClose,
	onSubmit,
	onSaveToBilance,
}) => {
	const { t } = useResource();
	const { rent, setRent, income, setIncome, savings, setSavings } =
		useOwnHomeEstimate({ open });

	return (
		<InspirationSheet
			open={open}
			preventScrollOnClose
			onClose={onClose}
			title={t(PageResources.title)}
			description={t(PageResources.description)}
			primaryLabel={t(PageResources.submit)}
			onPrimary={() =>
				onSubmit({ rent, income, savings: savings > 0 ? savings : undefined })
			}
			secondaryLabel={t(PageResources.saveToBilance)}
			onSecondary={onSaveToBilance}
		>
			<BoxedSliderField
				label={t(PageResources.rentLabel)}
				value={rent}
				onChange={setRent}
				{...OWN_HOME_RENT_FIELD}
			/>

			<BoxedSliderField
				label={t(PageResources.incomeLabel)}
				value={income}
				onChange={setIncome}
				{...OWN_HOME_INCOME_FIELD}
			/>

			<BoxedSliderField
				label={t(PageResources.savingsLabel)}
				value={savings}
				onChange={setSavings}
				{...OWN_HOME_SAVINGS_FIELD}
				hint={t(PageResources.savingsHint)}
			/>
		</InspirationSheet>
	);
};
